import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { openCloseAnimation, rotateAnimation } from './menu-item.animations';

import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss'],
  animations: [openCloseAnimation, rotateAnimation],
})
export class MenuItemComponent implements OnInit {
  @Input() menuItem: any = null;
  public isExpandable = false;
  @HostBinding('class.nav-item') isNavItem = true;
  @HostBinding('class.menu-open') isMenuExtended = false;
  public isMainActive = false;
  public isOneOfChildrenActive = false;

  constructor(private router: Router) {}

  ngOnInit(): void {
    if (
      this.menuItem &&
      this.menuItem.children &&
      this.menuItem.children.length > 0
    ) {
      this.isExpandable = true;
    }

    this.calculateIsActive(this.router.url);
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.calculateIsActive(event.url);
      });
  }

  public handleMainMenuAction() {
    if (this.isExpandable) {
      this.toggleMenu();
      return;
    }
    this.router.navigate(this.menuItem.path);
  }

  public toggleMenu() {
    this.isMenuExtended = !this.isMenuExtended;
  }

  public handleSubMenuAction(item: any) {
    if (item.children && item.children.length > 0) {
      item.isSubMenuExtended = !item.isSubMenuExtended;
    } else {
      this.router.navigate(item.path);
    }
  }

  public calculateIsActive(url: string) {
    this.isMainActive = false;
    this.isOneOfChildrenActive = false;

    if (this.isExpandable) {
      this.menuItem.children.forEach((item: any) => {
        if (url.indexOf(item.path) !== -1) {
          this.isOneOfChildrenActive = true;
          this.isMenuExtended = true;
          item.isSubMenuExtended = true; // Set the submenu as active
        } else {
          item.isSubMenuExtended = false; // Reset other submenus
        }
      });
    } else if (url.indexOf(this.menuItem.path) !== -1) {
      this.isMainActive = true;
    }

    if (!this.isMainActive && !this.isOneOfChildrenActive) {
      this.isMenuExtended = false;
    }
  }
}
